import { getBrowseConfig } from 'app/api/BrowseApi';
import { fetchPreview } from 'app/api/admin/browse/homePageApi';
import BrowseConstants from 'app/constants/BrowseConstants';

const fetchBrowseConfig = () => {
  return {
    types: [
      BrowseConstants.FETCH_BROWSE_REQUEST,
      BrowseConstants.FETCH_BROWSE_SUCCESS,
      BrowseConstants.FETCH_BROWSE_FAILURE
    ],
    apiRequest: (_state, apiClient) => getBrowseConfig(apiClient)
  };
};

const fetchBrowseHomePagePreview = ({ localeCode, browseHomePageId }) => {
  return {
    types: [
      BrowseConstants.FETCH_BROWSE_REQUEST,
      BrowseConstants.FETCH_BROWSE_SUCCESS,
      BrowseConstants.FETCH_BROWSE_FAILURE
    ],
    apiRequest: (_state, apiClient) => fetchPreview(apiClient, localeCode, browseHomePageId)
  };
};

export { fetchBrowseConfig, fetchBrowseHomePagePreview };
